import WexApp from './WexApp';

import Bootstrap from 'bootstrap/js/dist/util'; // Required.
import BootstrapCollapse from 'bootstrap/js/dist/collapse'; // Mobile menu.
import BootstrapDropdown from 'bootstrap/js/dist/dropdown'; // Navigation.
import BootstrapModal from 'bootstrap/js/dist/modal'; // Cities selection, magazine selection
import jQuery from 'jquery';

import MixinAnimation from '../mixins/Animation';
import MixinAssets from '../mixins/Assets';
import MixinDate from '../mixins/Date';
import MixinEvent from '../mixins/Event';
import MixinResponsive from '../mixins/Responsive';
import MixinVue from '../mixins/Vue';

// Locally used libraries.
import VueResource from 'vue-resource';
import Page from './Page';
import MixinString from "../mixins/String";
import MixinGtm from "../mixins/Gtm";

/**
 * Specific to this site.
 */
export default class extends WexApp {
    constructor(readyCallback, globalName = 'app') {
        super(readyCallback, globalName);

        this.addLib('Bootstrap', Bootstrap);
        this.addLib('BootstrapCollapse', BootstrapCollapse);
        this.addLib('BootstrapDropdown', BootstrapDropdown);
        this.addLib('BootstrapModal', BootstrapModal);
        this.addLib('jQuery', jQuery);
    }

    getMixins() {
        return {
            ...super.getMixins(),
            MixinAnimation,
            MixinString,
            MixinGtm,
            MixinAssets,
            // Used by timezones.
            MixinDate,
            // Modal openers.
            MixinEvent,
            // For responsive variations.
            MixinResponsive,
            // Required by magazine modal.
            MixinVue,
        };
    }

    addLib(name, object) {
        super.addLib(name, object);

        switch (name) {
            case 'vue':
                // Add vue-resource plugin.
                object.use(VueResource);
        }
    }

    getClassPage() {
        return Page;
    }

    getSelectedCurrency() {
        let currency = null;
        let currencyCodeUrlParameter = new URL(location.href).searchParams.get(
            'currency-code'
        );
        let currencies = appData.page.vars.currencies;
        let currencyChosenManually = appData.page.vars.currencyChosenManually;

        if (currencyCodeUrlParameter !== null) {
            // Url parameter has precedence over the user manually setting their currency
            currency = currencies.find(
                (currency) => currency.code === currencyCodeUrlParameter
            );
        } else if (
            appData.page.vars.user &&
            appData.page.vars.user.currency_id
        ) {
            currency = currencies.find(
                (currency) => currency.id === appData.page.vars.user.currency_id
            );
        } else if (appData.page.vars.currency && currencyChosenManually) {
            currency = appData.page.vars.currency;
        } else if (appData.page.vars.cityCurrency) {
            // Use the city's currency if a city is defined
            currency = appData.page.vars.cityCurrency;
        } else if (appData.page.vars.currency) {
            currency = appData.page.vars.currency;
        } else {
            // Fallback by default to Euros as we can't determine user's currency
            currency = currencies.find((currency) => currency.code === 'EUR');
        }

        return currency;
    }

    formatPrice(price, currencyCode) {
        let formattedPrice = '';

        if (currencyCode === 'CHF') {
            formattedPrice = 'Fr. ' + price + '.-';
        } else {
            let numberFormat = new Intl.NumberFormat(appData.trans.locale, {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0,
            });
            formattedPrice = numberFormat.format(price);
        }

        return formattedPrice;
    }

    /**
     * See Domains::getDomain for PHP version.
     */
    getDomain(lang = appData.trans.locale) {
        // 'current' is legacy. Should be removed.
        return appData.page.vars.domainsRegistry[appData.env]['current'][lang];
    }

    // Define a method to choose destination to redirect depending on lang.
    localSuggestionGetUrl(lang) {
        if (appData.trans.localeAllowed.indexOf(lang) !== -1) {
            let loc = window.location;
            let parts = loc.pathname.split('/');
            let url = loc.protocol + '//' + loc.hostname;
            let search = loc.search;

            // We are on an url that contains lang prefix.
            if (parts[1].length === 2 && parts[1] !== lang) {
                parts = parts.splice(2);
                parts.unshift(lang);

                url += '/' + parts.join('/');
            } else {
                // Return the same path.
                url += loc.pathname;
                search = (search || '?') + '&set_locale=' + lang;
            }

            return url + search + loc.hash;
        }
    }
}
